import React, { useState, useEffect } from 'react';
import './Dashboard.css';

// ダッシュボードコンポーネント
const Dashboard = () => {
  const [constructionData, setConstructionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // データ取得関数
    const fetchConstructionData = async () => {
      try {
        setLoading(true);
        
        // 実際のAPIを使用する場合は、以下のようなコードを使用します
        // const apiKey = 'YOUR_API_KEY'; // 実際のAPIキーに置き換える
        // const response = await fetch('https://opendata.resas-portal.go.jp/api/v1/construction/...', {
        //   headers: {
        //     'X-API-KEY': apiKey
        //   }
        // });
        // const data = await response.json();
        
        // デモ用のモックデータ
        // 実際のAPIを使用する場合は、上記のコメントアウトされたコードを使用してください
        const mockData = {
          prefectures: [
            { name: '北海道', activeProjects: 245, completedLastMonth: 32, newProjects: 18 },
            { name: '東京都', activeProjects: 578, completedLastMonth: 67, newProjects: 43 },
            { name: '大阪府', activeProjects: 312, completedLastMonth: 41, newProjects: 27 },
            { name: '愛知県', activeProjects: 289, completedLastMonth: 38, newProjects: 22 },
            { name: '福岡県', activeProjects: 198, completedLastMonth: 25, newProjects: 15 }
          ],
          summary: {
            totalActiveProjects: 3245,
            totalCompletedLastMonth: 412,
            totalNewProjects: 287,
            averageProjectDuration: 8.5, // 月単位
            topCategory: '道路工事',
            updateDate: '2025年3月15日'
          }
        };
        
        // データ取得の遅延をシミュレート
        setTimeout(() => {
          setConstructionData(mockData);
          setLoading(false);
        }, 1000);
        
      } catch (err) {
        console.error('建設データの取得中にエラーが発生しました:', err);
        setError('データの取得に失敗しました。後でもう一度お試しください。');
        setLoading(false);
      }
    };

    fetchConstructionData();
  }, []);

  // ローディング中の表示
  if (loading) {
    return (
      <div className="dashboard-loading">
        <p>データを読み込み中...</p>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // エラー時の表示
  if (error) {
    return (
      <div className="dashboard-error">
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>再読み込み</button>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h3>建設現場データダッシュボード</h3>
        <p className="update-date">最終更新: {constructionData.summary.updateDate}</p>
      </div>
      
      <div className="dashboard-summary">
        <div className="summary-card">
          <h4>全国の進行中プロジェクト</h4>
          <p className="summary-value">{constructionData.summary.totalActiveProjects}</p>
        </div>
        <div className="summary-card">
          <h4>先月完了したプロジェクト</h4>
          <p className="summary-value">{constructionData.summary.totalCompletedLastMonth}</p>
        </div>
        <div className="summary-card">
          <h4>新規プロジェクト</h4>
          <p className="summary-value">{constructionData.summary.totalNewProjects}</p>
        </div>
      </div>
      
      <div className="dashboard-details">
        <h4>主要都道府県のプロジェクト状況</h4>
        <div className="prefecture-table-container">
          <table className="prefecture-table">
            <thead>
              <tr>
                <th>都道府県</th>
                <th>進行中</th>
                <th>先月完了</th>
                <th>新規</th>
              </tr>
            </thead>
            <tbody>
              {constructionData.prefectures.map((prefecture, index) => (
                <tr key={index}>
                  <td>{prefecture.name}</td>
                  <td>{prefecture.activeProjects}</td>
                  <td>{prefecture.completedLastMonth}</td>
                  <td>{prefecture.newProjects}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      <div className="dashboard-footer">
        <p>平均プロジェクト期間: {constructionData.summary.averageProjectDuration}ヶ月</p>
        <p>最も多いカテゴリ: {constructionData.summary.topCategory}</p>
      </div>
    </div>
  );
};

export default Dashboard;
